import { FocusNode } from '@please/lrud'
import styled from 'styled-components'

export const ContentContainer = styled.div`
  display: flex;
  width: 1280px;
  min-height: 720px;
  margin: 40px 0;
  justify-content: space-between;
`

export const UsercentricsContainer = styled(FocusNode)`
  position: fixed;
  background: ${(props) => props.theme.colors.dialogPopup.overlay};
  width: 1920px;
  height: 1080px;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
`
export const UsercentricsBox = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 960px;
  height: 960px;
  padding: 110px 40px 20px;
  border: 4px solid ${(props) => props.theme.colors.dialogPopup.border};
  border-radius: 24px;
  overflow: hidden;
  background: ${(props) => props.theme.colors.dialogPopup.background.start};
`
export const UsercentricsScreenscontent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 1 100%;
`
export const HeaderLogoEl = styled.img`
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  width: 240px;
`

export const Title = styled.h2`
  width: 100%;
  font-size: 30px;
  line-height: 1.2;
  color: ${(props) => props.theme.colors.dialogPopup.text};
  font-weight: 500;
  padding-bottom: 24px;
  text-align: left;
`
export const Description = styled.p`
  width: 100%;
  font-size: 20px;
  line-height: 26px;
  white-space: pre-line;
  padding-bottom: 50px;
  margin: 0 auto;
  color: ${(props) => props.theme.colors.dialogPopup.text};
`
export const ButtonWrapper = styled(FocusNode)`
  width: 100%;
  padding-top: 16px;
  button {
    margin: 8px 0;
  }
`
export const TabsRow = styled(FocusNode)`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  margin-bottom: 10px;
  height: 62px;
  background: ${(props) => props.theme.colors.dialogPopup.background.start};
  z-index: 10;
  &:after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    height: 4px;
    width: 100%;
    background-color: ${(props) => props.theme.colors.tabs.separator};
  }
`
export const TabElem = styled(FocusNode)<{
  $activeTab: boolean
}>`
  position: relative;
  display: flex;
  min-width: 198px;
  padding: 0 15px;
  justify-content: center;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 58px;
  height: 62px;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.tabs.text};
  white-space: nowrap;
  box-shadow: none;
  cursor: pointer;
  background-color: ${({ $activeTab, theme }) =>
    $activeTab ? theme.colors.tabs.activeElem.background : 'transparent'};
  &:after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    height: 4px;
    width: 100%;
    background-color: ${({ $activeTab, theme }) =>
      $activeTab ? theme.colors.tabs.activeElem.border : 'transparent'};
  }
  &.isFocusedLeaf {
    opacity: 1;
    background-color: ${(props) =>
      props.theme.colors.tabs.focusedElem.background};
    &:after {
      background-color: ${(props) =>
        props.theme.colors.tabs.focusedElem.border};
    }
  }
`
export const TabContent = styled(FocusNode)<{
  $activeTab: boolean
}>`
  height: ${({ $activeTab }) => ($activeTab ? 'auto' : '0')};
  min-height: ${({ $activeTab }) => ($activeTab ? '500px' : '0')};
  overflow: ${({ $activeTab }) => ($activeTab ? 'auto' : 'hidden')};
  opacity: ${({ $activeTab }) => ($activeTab ? '1' : '0')};
  transition: height 0.3s;
`
export const Section = styled(FocusNode)`
  position: relative;
  background-color: ${(props) =>
    props.theme.colors.dialogPopup.list.background};
  padding: 16px;
  border-radius: 8px;
  margin: 12px 0;
  &.isFocused {
    background: ${(props) =>
      props.theme.colors.dialogPopup.list.focusedElem.background};
  }
`
export const SectionContent = styled(FocusNode)`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
`
export const SectionTitleWrapper = styled.div`
  flex: 0 1 100%;
  color: ${(props) => props.theme.colors.dialogPopup.text};
`
export const SectionTitle = styled.header`
  padding: 4px 0;
  font-size: 24px;
  line-height: 26px;
  font-weight: 500;
  color: ${(props) => props.theme.colors.dialogPopup.text};
`
export const SectionDescription = styled.p`
  padding: 4px 0;
  padding-bottom: 0;
  font-size: 16px;
  line-height: 22px;
  opacity: 0.8;
  color: ${(props) => props.theme.colors.dialogPopup.text};
`

export const SectionTogglesWrapper = styled(FocusNode)`
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: flex-end;
`
export const ToggleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 16px;
`
export const ToggleDescription = styled.p`
  padding: 4px 20px;
  font-size: 16px;
  line-height: 22px;
  opacity: 0.8;
  color: ${(props) => props.theme.colors.dialogPopup.text};
`
export const ViewMoreContainer = styled.div`
  height: 40px;
  width: 40px;
  margin: 10px;
`
export const ViewMore = styled(FocusNode)`
  color: ${(props) => props.theme.colors.dialogPopup.text};
  height: 40px;
  width: 40px;
  border: 2px solid ${(props) => props.theme.colors.tabs.separator};
  &.isFocusedLeaf {
    border: 2px solid ${(props) => props.theme.colors.tabs.focusedElem.border};
  }
`
export const ViewMoreIcon = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
`
export const AdditionalSectionWrapper = styled(FocusNode)<{
  $isVisible: boolean
}>`
  color: ${(props) => props.theme.colors.dialogPopup.text};
  border-top: 2px solid ${(props) => props.theme.colors.tabs.separator};
  opacity: ${({ $isVisible }) => ($isVisible ? '1' : '0')};
  height: ${({ $isVisible }) => ($isVisible ? 'auto' : '0')};
  padding-top: ${({ $isVisible }) => ($isVisible ? '16px' : '0')};
  margin-top: ${({ $isVisible }) => ($isVisible ? '16px' : '0')};
  overflow: hidden;
`
export const AdditionalSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
export const AdditionalSectionTitle = styled.header`
  padding: 8px 0;
  font-size: 22px;
  line-height: 24px;
  font-weight: 400;
  opacity: 0.9;
  color: ${(props) => props.theme.colors.dialogPopup.text};
`
export const AdditionalToggleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
